var request = require('superagent');
var UriTemplate = require('uritemplate');
var config = window.Config;
var api = {};
var announcementParams= {'_offset':0,'_max':10};
var authToken = undefined;
var StateActions = require('../actions/StateActions');
var TrendActions = require('../actions/TrendActions');
var AnnouncementActions = require('../actions/AnnouncementActions');

  function init(){
    authToken = localStorage.getItem("authToken");
    return new Promise(function(resolve, reject) {
      getApiScheme().then(function() {
        resolve();
        if(authToken !== null){
          checkToken();
        }
      },function() {
        reject();
      })
    });
  }

  function checkToken(){
    request
      .get(getURL(api._links.session,{id:authToken}))
      .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json'})
      .end(function(err){
        if(err){
          localStorage.removeItem('authToken');
        }
      });
  }

  function login(usr,passwd){
    return new Promise(function(resolve, reject) {
      request
        .post(getURL(api._links.session))
        .send({ username: usr, password: passwd })
        .set('Accept', 'application/json')
        .end(function(err, res){
          if(!err){
            var resp = JSON.parse(res.text);
            localStorage.setItem('authToken',resp.token);
          }
          err ? reject(err) : resolve(res);
        });
    });
  }

  function logout(){
    return new Promise(function(resolve, reject) {
      request
        .delete(getURL(api._links.session,{id:authToken}))
        .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json'})
        .end(function(err, res){
          localStorage.removeItem('authToken');
          authToken = null;
          location.reload();
          err ? reject(err) : resolve(res);
        });
    });
  }


  function isAuthorized(){
    return !!(authToken !== null && authToken !== undefined);
  }

  function loadData() {
    return new Promise(function(resolve, reject) {
      if (isApiSchemeLoaded()) {
        Promise.all([getAnnouncements(), getServices(), getTrend()]).then(function () {
            resolve();
          },
          function () {
            reject();
          });
      } else {
        getApiScheme().then(function () {
          Promise.all([getAnnouncements(), getServices(), getTrend()]).then(function () {
              resolve();
            },
            function () {
              reject();
            });
        });
      }
    });
  }

  function isApiSchemeLoaded(){
   return Object.keys(api).length > 0;
  }

  function getApiScheme() {
    return new Promise(function(resolve, reject) {
      request
      .get(config.url + '/about')
      .end(function(err, res){
        api = JSON.parse(res.text);
        err ? reject(err) : resolve(res);
      });
    });
  }

  function editState(state) {
    return new Promise(function(resolve, reject) {
      request
        .put(getURL(api._links.state))
        .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json', 'Content-Type': 'application/json'})
        .send(state)
        .end(function(err, res){
          getServices();
          err ? reject(err) : resolve(res);
        });
    });
  }

  function getServices() {
    return new Promise(function(resolve, reject) {
      request
        .get(getURL(api._links.state))
        .end(function(err, res){
          StateActions.receiveState(JSON.parse(res.text));
          err ? reject(err) : resolve(res);
        });
    });
  }

  function getTrend(){
    return new Promise(function(resolve, reject) {
      request
          .get(getURL(api._links.trend,{days:1}))
          .end(function(err, res){
            TrendActions.receiveState(JSON.parse(res.text));
            err ? reject(err) : resolve(res);
          });
    });
  }

  function getAnnouncements(params) {
    if(params) {
      announcementParams = params;
    }
    return new Promise(function(resolve, reject) {
      request
        .get(getURL(api._links.announcements,announcementParams))
        .end(function(err, res){
          AnnouncementActions.receiveState(JSON.parse(res.text));
          err ? reject(err) : resolve(res);
        });
    });
  }

  function getAnnouncement(id) {
    return new Promise(function(resolve, reject) {
      request
        .get(getURL(api._links.announcement,{id:id}))
        .end(function(err, res){
          err ? reject(err) : resolve(JSON.parse(res.text));
        });
    });
  }

  function addAnnouncement(data) {
    return new Promise(function(resolve, reject) {
      request
        .post(getURL(api._links.announcements))
        .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json', 'Content-Type': 'application/json'})
        .send(data)
        .end(function(err, res){
          getAnnouncements();
          err ? reject(err) : resolve(res);
        });
    });
  }

  function editAnnouncement(data) {
    return new Promise(function(resolve, reject) {
      request
        .put(data._links.self.href)
        .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json', 'Content-Type': 'application/json'})
        .send(data)
        .end(function(err, res){
          getAnnouncements();
          err ? reject(err) : resolve(res);
        });
    });
  }

  function deleteAnnouncement(data) {
    return new Promise(function(resolve, reject) {
      request
        .delete(data._links.self.href)
        .set({'Authorization': 'Bearer ' + authToken,'Accept': 'application/json', 'Content-Type': 'application/json'})
        .end(function(err, res){
          getAnnouncements();
          err ? reject(err) : resolve(res);
        });
    });
  }

  function getURL(link, templateValues) {
  var url = typeof(link) === 'object' ? link.href : link;
  var templated = typeof(link) === 'object' ? link.templated : false;
  if (templated) {
    var escapedTemplateValues = {};
    for (var key in templateValues) {
      if (key !== 'runtimeParams') {
        escapedTemplateValues[encodeURIComponent(key)] = templateValues[key];
      }
    }
    url = UriTemplate.parse(url).expand(escapedTemplateValues);
  }
  if (templateValues && templateValues.runtimeParams) {
    var queryparams = [];
    for (var i = 0; i < templateValues.runtimeParams.length; i++) {
      queryparams.push(templateValues.runtimeParams[i] + '=' + templateValues.runtimeParams[templateValues.runtimeParams[i]]);
    }
    if (url.indexOf('?') === -1) {
      url += '?';
    } else {
      url += '&';
    }
    url += queryparams.join('&');
  }
  return decodeURIComponent(url);
  }


module.exports = {
  init:init,
  loadData:loadData,
  login:login,
  logout:logout,
  getServices:getServices,
  getTrend:getTrend,
  getAnnouncements:getAnnouncements,
  getAnnouncement:getAnnouncement,
  addAnnouncement:addAnnouncement,
  editAnnouncement:editAnnouncement,
  deleteAnnouncement:deleteAnnouncement,
  isAuthorized:isAuthorized,
  editState:editState
};


/** WEBPACK FOOTER **
 ** ./src/utils/MonitorApi.js
 **/